<template>
	<div class="base">

    <slot></slot>

			<section role="region" aria-label="תחתית הדף" id="footerC" class="footer">
			<div class="back-yards-credit">
				<div class="footer-logo">
					<div class="footer-logo-img">
						<img alt="החצר" class="fillImg" src="images/site-bottom-logo.png"/>
					</div>
					<br>
					<a target="_blank" href="https://www.facebook.com/yardbands">
						<div id="social1" class="footer-social">
							<img alt="החצר בפייסבוק" class="fillImg" src="images/social1.png"/>
						</div>
					</a>
					<a target="_blank" href="https://www.instagram.com/yardbands">
						<div id="social2" class="footer-social">
							<img alt="החצר באינסטגרם" class="fillImg" src="images/social2.png"/>
						</div>
					</a>
					<a target="_blank" href="https://www.youtube.com/channel/UCSbxr9Lhw29M_cVdDDsW8EA/playlists">
						<div id="social3" class="footer-social">
							<img alt="החצר ביוטיוב" class="fillImg" src="images/social3.png"/>
						</div>
					</a>
				</div>
				<div class="contacts">
					<p><strong>
					ליצירת קשר <a href="tel:0547737094">054-7737094</a>
					 | <a href="mailto:OFFICE@YARDBANDS.COM">OFFICE@YARDBANDS.COM</a>
					<br>
					כל הזכויות שמורות לחצר
					</strong>
					</br>
					<a target="_blank" href="http://yard-bands.herokuapp.com/privacyPolicy.pdf"><strong>מדיניות פרטיות</strong></a>|
					<a target="_blank" href="http://yard-bands.herokuapp.com/privacyPolicy.pdf"><strong>תנאי שימוש</strong></a>
					</p>
				</div>
			</div>
		</section>
			<div role="navigation" aria-label="קרדיט" class="credits">
				<p><strong><a style="color:#FF632B" href="https://www.designninjas.org">DESIGN: DOVEV ALPERSON (DESIGN NINJAS)</a> | CODE BY YUVAL DERI (FUTURE CACHET) | PHOTOGRAPY BY ILAN BURLA</strong></p>
			</div>
  </div>
</template>

<script>
  import VLink from '../components/VLink.vue'
  import page from 'page'
  import VueScrollTo from 'vue-scrollto'
  import TalkToMeHeader from '../components/TalkToMeHeader.vue'
  import TalkToMe from '../components/TalkToMe.vue'
  export default {
    components: {
      VLink,TalkToMeHeader,TalkToMe
    },
	created () {
		window.addEventListener('scroll', this.handleScroll);
		this.videoIsMuted = true;
		this.videoPlaying = true;
		this.menuVisible = false;
		this.showContactDialog = false;
		this.auditionButtonOpen = false;
		this.scrollAnimationProgress = 1.0 - (Math.min(window.scrollY, 500) / 500.0);

	},
	destroyed () {
		window.removeEventListener('scroll', this.handleScroll);
	},
	data() {
		return {
			videoIsMuted : true,
			videoPlaying : true
		}
	},
	methods: {
		PauseOrPlayVideo() {
			this.videoPlaying = !this.videoPlaying;
			jwplayer("video-player").play(this.videoPlaying);
		},
		MuteOrVolumeVideo() {
			this.videoIsMuted = !this.videoIsMuted;

			jwplayer("video-player").setMute(this.videoIsMuted);

		},
		scrollToFaqs() {
			this.$scrollTo("#FAQS",800, {'offset':-180})
		},
		scrollToGallery() {
			if (!window.location.href.substring(window.location.origin.length).includes('home')) {
				page.redirect('/home');
				setTimeout(function(){
					window.pageLoaded();
					this.$scrollTo("#gallery", 800, {'offset':-200})
				}.bind(this),500);
			}
			else {
				this.$scrollTo("#gallery", 800, {'offset':-200})
			}
		},
		scrollToWorking(){
			if (!window.location.href.substring(window.location.origin.length).includes('home')) {
				page.redirect('/home');
				setTimeout(function(){
					window.pageLoaded();
					this.$scrollTo("#working", 800, {'offset':-250})
				}.bind(this),500);
			}
			else {
				this.$scrollTo("#working", 800, {'offset':-250})
			}
		},
		scrollToTeam() {
			if (!window.location.href.substring(window.location.origin.length).includes('team')) {
				page.redirect('/team');
				setTimeout(function(){
					window.pageLoaded();
					this.$scrollTo("#team", 800, {'offset':-250})
				}.bind(this),500);
			}
			else {
				this.$scrollTo("#team", 800, {'offset':-250})
			}
		},
		scrollToHome() {
			if (!window.location.href.substring(window.location.origin.length).includes('home')) {
				page.redirect('/home');
				this.$scrollTo("body", 0, {'offset':0})
				setTimeout(function(){
					window.pageLoaded();
				}.bind(this),500);

			}
			else {
				this.$scrollTo("body", 0, {'offset':0})
			}
		},
		handleScroll() {
			this.scrollAnimationProgress = 1.0 - (Math.min(window.scrollY, 500) / 500.0);
			this.$forceUpdate();
		},
		logoHeaderWidth : function() {
			return this.scrollAnimationProgress * 100 +120
		},
		logoHeaderHeight : function() {
			 return this.scrollAnimationProgress * 60 + 60
		},
		logoHeaderPadding : function() {
			 return (1-this.scrollAnimationProgress) * 5
		},
		showMenu() {
			this.menuVisible = !this.menuVisible;
			this.$forceUpdate();
		},
		toggleAudition() {
			this.auditionButtonOpen = !this.auditionButtonOpen
			this.$forceUpdate();
		},
		toggleTalkToMe() {
			this.showContactDialog = !this.showContactDialog;
			this.$forceUpdate();
		}
	}
  }
</script>

<style scoped>
  .container {
    width: 100%;
    margin: 0 auto;
    padding: 0;
    background: #000000;
  }
</style>



// WEBPACK FOOTER //
// Origami.vue?080b7af9